/**
 * Which section the owner last opened, and when they opened each one. Kept
 * per device: it only steers the home screen and the "recent" group, so a
 * blocked or wiped storage just means a first-run screen again.
 */
const KEY = "mioscape.sections";
const KEEP = 20;

interface Memory {
  last?: string;
  visits: Record<string, string>;
}

function read(): Memory {
  try {
    const raw = window.localStorage.getItem(KEY);
    const value: unknown = raw ? JSON.parse(raw) : null;
    if (typeof value !== "object" || value === null) return { visits: {} };
    const { last, visits } = value as Record<string, unknown>;
    return {
      last: typeof last === "string" ? last : undefined,
      visits:
        typeof visits === "object" && visits !== null
          ? (visits as Record<string, string>)
          : {},
    };
  } catch {
    return { visits: {} };
  }
}

export function lastSection(): string | undefined {
  return read().last;
}

export function sectionVisits(): Record<string, string> {
  return read().visits;
}

export function rememberSection(id: string, at: Date = new Date()): void {
  const memory = read();
  const visits = Object.fromEntries(
    Object.entries({ ...memory.visits, [id]: at.toISOString() })
      .sort(([, a], [, b]) => b.localeCompare(a))
      .slice(0, KEEP),
  );
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ last: id, visits }));
  } catch {
    // Storage is a convenience here; the app works the same without it.
  }
}
